/* eslint-disable camelcase */
export default class Commission {
  app_user_id = null;
  partner_id = null;
  app_company_product_id = null;
  is_included = true;
  is_excluded = false;
  start_date = '';
  first_year_rate = '';
  second_year_rate = '';
  third_year_rate = '';
  fourth_year_rate = '';
  fifth_year_rate = '';
  is_fixed_rate = false;
  fixed_rate = '';
  fixed_rate_start_date = '';
  fixed_rate_expire_date = '';
  created_by = '';
  updated_by = '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Commission.js